import React, { useRef, useState, useCallback } from "react";
import { Drawer, Button } from "antd";
import VDPSelector from "../vdpSelector";

const VehicleDetailPage = ({ open, onClose, text, setmessageText, handleInsertLink, ...props }) => {
  const vdpSelectorRef = useRef();
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [buttonText, setButtonText] = useState("Add Vehicle");

  // Callback functions to update state from child component
  const onSelectedVehiclesChange = useCallback(vehicles => {
    setSelectedVehicles(vehicles);
    setButtonText(vehicles.length > 1 ? "Add Vehicles" : "Add Vehicle");
  }, []);

  const handleAddVehicles = async () => {
    if (vdpSelectorRef.current) {
      setIsLoading(true);
      try {
        await vdpSelectorRef.current.addVehicles();
      } finally {
        setIsLoading(false);
      }
    }
  };

  const footer = (
    <div className="flex justify-start gap-3">
      <Button
        type="primary"
        loading={isLoading}
        disabled={selectedVehicles?.length === 0}
        onClick={handleAddVehicles}
      >
        {buttonText}
      </Button>
      <Button onClick={onClose}>Cancel</Button>
    </div>
  );

  return (
    <Drawer
      title="Select Vehicle From Inventory"
      placement="right"
      size="large"
      onClose={onClose}
      open={open}
      width={600}
      footer={footer}
      styles={{ body: { padding: "1rem" } }}
    >
      <VDPSelector
        ref={vdpSelectorRef}
        text={text}
        setmessageText={setmessageText}
        handleInsertLink={handleInsertLink}
        onClose={onClose}
        onSelectedVehiclesChange={onSelectedVehiclesChange}
        {...props}
      />
    </Drawer>
  );
};

export default VehicleDetailPage;
